/**
 * The configuration here is hardcoded based on teh CDN solution we have chosen, i.e. Net Storage.
 * This will allow us to pull down common assets via the CDN.
 * The CDN path mentioned here (https://x.nab.com.au/static-shared/nab) is production ready
 * and can be used in any environment.
 * Currently we have opened up support for Fonts only, but this can be extended to any static assets
 *
 * For testing in local, you will be able to use this setup as is.
 * But you can use the customCDN property on GlobalStyles component
 * to provide any other test path that allows you to serve the files.
 * Once tested, for any assets to be uploaded to the CDN path, you will have to approach NAB-X support.
 */
export var config = {
  cdnUrl: 'https://x.nab.com.au/static-shared/nab',
  assetsPath: {
    /**
     * Make sure all the assets support are provided with relative path to the cdnUrl above.
     * For every asset supported please add a key, key value pair.
     * Make sure the key name is added in the enumerator of the `assetTypes` below
     */
    fonts: '/fonts/v1'
  }
};
/**
 * The assetType is provided as enum to match the assetsPath keys. so devs aca use it instead of passing string.
 */

export var assetTypes = {
  fonts: 'fonts'
};
export default config;